module.exports = __webpack_public_path__ + "img/State=12.b736d590.svg";